import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIndividualPlanIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 28 30",
	fill: "currentColor",
	stroke: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M20.9939 9.01058L15.6666 5.93496C15.1599 5.64234 14.5851 5.48828 13.9999 5.48828C13.4148 5.48828 12.84 5.64234 12.3333 5.93496L7.0064 9.01058C6.59257 9.2585 6.23805 9.59405 5.96777 9.99364L14.0001 14.6253L22.0328 9.99402C21.7625 9.59426 21.4079 9.25858 20.9939 9.01058Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .5,
			d: "M15.666 24.0109L20.9931 20.9352C21.4999 20.6426 21.9207 20.2219 22.2132 19.7151C22.5058 19.2084 22.6598 18.6336 22.6598 18.0484V11.897C22.6518 11.4972 22.571 11.1023 22.4215 10.7314L14.416 15.3474V24.4031C14.8547 24.3574 15.2798 24.224 15.666 24.0109Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.33887 11.8973V18.0487C5.33887 18.6338 5.49291 19.2087 5.78551 19.7154C6.07811 20.2221 6.49896 20.6429 7.00574 20.9354L12.333 24.0112C12.7192 24.2243 13.1443 24.3577 13.583 24.4034V15.3477L5.57712 10.7314C5.42756 11.1024 5.34683 11.4974 5.33887 11.8973Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.4102 21.6577L16.083 24.733C15.4493 25.0977 14.7309 25.2896 13.9997 25.2896C13.2685 25.2896 12.5501 25.0977 11.9164 24.733L6.58923 21.6577C6.08982 21.3565 5.65987 20.953 5.32773 20.4736L1.36523 22.7439C1.62467 23.1024 1.95362 23.4049 2.33248 23.6336L12.3328 29.4073C12.8395 29.6998 13.4143 29.8539 13.9995 29.8539C14.5846 29.8539 15.1594 29.6998 15.6661 29.4073L25.6665 23.6336C26.0455 23.405 26.3745 23.1025 26.634 22.744L22.6715 20.4738C22.3394 20.9531 21.9095 21.3566 21.4102 21.6577Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.50595 18.0483V11.8976C4.5073 11.1664 4.70039 10.4483 5.06596 9.81497C5.43153 9.18167 5.95679 8.65531 6.58933 8.28842L11.9165 5.21305C12.4299 4.92868 12.9981 4.75736 13.5831 4.71055V0.146484C13.1444 0.192266 12.7194 0.325651 12.3331 0.538735L2.3327 6.31261C1.82595 6.60514 1.40513 7.02593 1.11256 7.53266C0.819994 8.0394 0.665984 8.61423 0.666016 9.19936V20.7467C0.674581 21.1863 0.771037 21.6199 0.949703 22.0217L4.90858 19.7534C4.65376 19.2205 4.51645 18.639 4.50595 18.0483Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M25.6665 6.31261L15.666 0.538735C15.2798 0.325676 14.8547 0.192293 14.416 0.146484V4.71055C15.001 4.75737 15.5693 4.92869 16.0827 5.21305L21.4098 8.28842C22.0424 8.65532 22.5676 9.18168 22.9332 9.81498C23.2987 10.4483 23.4918 11.1664 23.4931 11.8976V18.0483C23.4826 18.6389 23.3453 19.2203 23.0905 19.7532L27.0494 22.0215C27.2281 21.6197 27.3245 21.1862 27.3331 20.7465V9.19923C27.3331 8.61414 27.179 8.03935 26.8865 7.53265C26.5939 7.02594 26.1732 6.60516 25.6665 6.31261Z",
			fill: "white"
		})
	]
});
export default SvgIndividualPlanIcon;
